import { render, staticRenderFns } from "./PluginLoadingCount.vue?vue&type=template&id=c2735404&scoped=true&"
import script from "./PluginLoadingCount.vue?vue&type=script&lang=js&"
export * from "./PluginLoadingCount.vue?vue&type=script&lang=js&"
import style0 from "./PluginLoadingCount.vue?vue&type=style&index=0&id=c2735404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2735404",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
